import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { FETCH_STATUSES } from "enums";

const initialState = {
  status: FETCH_STATUSES.idle,
  error: null,
  labelFunc: null,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setStatus(state, { payload }) {
      state.status = payload;
    },
    setError(state, { payload }) {
      state.error = payload;
    },
    setLabelFunc(state, { payload }) {
      state.labelFunc = payload;
    },
    clearLabelFunc(state) {
      state.labelFunc = null;
    },
    reset(state) {
      const { error, status } = initialState;
      state.error = error;
      state.status = status;
    },
  },
});

export const { actions } = loadingSlice;
export default loadingSlice.reducer;

export const useLoadingActions = () => {
  const dispatch = useDispatch();

  const reset = () => dispatch(loadingSlice.actions.reset());
  const setError = (error) => dispatch(loadingSlice.actions.setError(error));
  const setStatus = (status) => dispatch(loadingSlice.actions.setStatus(status));
  const setLabelFunc = (func) => dispatch(loadingSlice.actions.setLabelFunc(func));
  const clearLabelFunc = () => dispatch(loadingSlice.actions.clearLabelFunc());

  return {
    reset,
    setError,
    setStatus,
    setLabelFunc,
    clearLabelFunc,
  };
};
